import { Trans } from "@lingui/macro";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import React, { FunctionComponent } from "react";
import "./withBrowserWarning.css";
import edge from "./edge.svg";
import firefox from "./firefox.svg";
import chrome from "./chrome.svg";

export interface Props {}

function isInternetExplorer() {
  const userAgent = navigator.userAgent;
  const isIE = userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1;
  return isIE;
}

export const WithBrowserWarning: FunctionComponent<Props> = ({ children }) => {
  const applicationName = useWhiteLabelSetting("applicationName") as string;

  if (!isInternetExplorer()) return <>{children}</>;

  return (
    <div id="unsupportedBrowserWarning">
      <h1>
        <Trans>Uw browser is niet compatible met {applicationName}</Trans>
      </h1>
      <p className="suggestion">
        <Trans>Wij raden u aan een andere browser te gebruiken</Trans>
      </p>
      <div id="alternative-browsers">
        <div className="browser-card">
          <img src={edge} alt="Edge" height={100} />
          <a href="https://www.microsoft.com/nl-nl/edge/" target="_blank" rel="noreferrer">
            Edge
          </a>
        </div>
        <div className="browser-card">
          <img src={chrome} alt="Chrome" height={100} />
          <a href="https://www.google.com/chrome/" target="_blank" rel="noreferrer">
            Chrome
          </a>
        </div>
        <div className="browser-card">
          <img src={firefox} alt="Firefox" height={100} />
          <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" rel="noreferrer">
            Firefox
          </a>
        </div>
      </div>
    </div>
  );
};

WithBrowserWarning.displayName = "WithBrowserWarning";
